// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__BP257"};